import { useState } from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export function OtpStep({ otp, onBack, onDone }) {
  const { login } = useAuth();
  const [code, setCode] = useState("");
  const [error, setError] = useState(otp.delivered === false ? "We couldn't deliver the code to this email. Try resending, or contact CCMIntel." : "");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);

  const verify = async (e) => {
    e.preventDefault();
    setBusy(true); setError(""); setInfo("");
    try { await login("/auth/verify-otp", { otp_id: otp.otp_id, code }); onDone(); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };
  const resend = async () => {
    setError(""); setInfo("");
    try { await api.post("/auth/resend-otp", { otp_id: otp.otp_id }); setInfo("A new code has been sent."); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <form onSubmit={verify} className="w-full max-w-sm fade-up" data-testid="otp-form">
      <ShieldCheck className="h-10 w-10 text-[#03AB9E] mb-6" />
      <h2 className="text-2xl font-bold tracking-tight">Verify it's you</h2>
      <p className="text-sm text-slate-400 mt-1 mb-8" data-testid="otp-sent-to">
        New device or browser detected. Enter the 6-digit code sent to <span className="text-slate-200">{otp.email}</span>. This device will be remembered for 30 days.
      </p>
      <Input data-testid="otp-code-input" inputMode="numeric" autoComplete="one-time-code" maxLength={6} placeholder="000000" value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} required className="h-12 bg-slate-900 border-slate-700 text-center text-xl tracking-[0.5em] font-mono" />
      {error && <p className="text-sm text-red-400 mt-3" data-testid="otp-error">{error}</p>}
      {info && <p className="text-sm text-[#03AB9E] mt-3" data-testid="otp-info">{info}</p>}
      <button data-testid="otp-submit-button" disabled={busy || code.length !== 6}
        className="mt-6 w-full h-11 rounded-md bg-[#1074BA] hover:bg-[#0D629E] text-white font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-60">
        {busy ? "Verifying…" : "Verify & sign in"} <ArrowRight className="h-4 w-4" />
      </button>
      <div className="mt-4 flex justify-between text-sm text-slate-400">
        <button type="button" onClick={resend} className="hover:text-[#F58B23] transition-colors" data-testid="otp-resend-button">Resend code</button>
        <button type="button" onClick={onBack} className="hover:text-[#F58B23] transition-colors" data-testid="otp-back-button">Use a different account</button>
      </div>
    </form>
  );
}
